module.exports = __webpack_public_path__ + "assets/eb6266b2ab0e80028b09bd825adb0ed2.mp3";